import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const base =
  "group inline-flex items-center gap-3 rounded-full pl-5 pr-1.5 py-1.5 text-[15px] font-[520] tracking-[-0.01em] transition-[background-color,color,border-color,transform] duration-300 active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-signal";
const variants = {
  primary: "bg-fg text-ink hover:bg-signal",
  ghost: "border border-white/15 text-fg hover:border-white/40 hover:bg-white/[0.04] backdrop-blur-md",
};
const knob = {
  primary: "bg-ink text-fg",
  ghost: "bg-white/10 text-fg",
};

const Inner = ({ children, variant }) => (
  <>
    <span>{children}</span>
    <span className={`grid h-9 w-9 place-items-center overflow-hidden rounded-full ${knob[variant]}`}>
      <ArrowUpRight className="h-4 w-4 transition-transform duration-500 ease-out group-hover:-translate-y-[2px] group-hover:translate-x-[2px] group-hover:rotate-45" />
    </span>
  </>
);

export const PillLink = ({ to, href, onClick, children, variant = "primary", className = "", testId, type = "button", disabled, ...props }) => {
  const cls = `${base} ${variants[variant]} ${className} ${disabled ? "opacity-60 pointer-events-none" : ""}`;
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testId} {...props}>
        <Inner variant={variant}>{children}</Inner>
      </a>
    );
  }
  if (to) {
    return (
      <Link to={to} className={cls} data-testid={testId} onClick={onClick} {...props}>
        <Inner variant={variant}>{children}</Inner>
      </Link>
    );
  }
  return (
    <button type={type} onClick={onClick} className={cls} data-testid={testId} disabled={disabled} {...props}>
      <Inner variant={variant}>{children}</Inner>
    </button>
  );
};

export const TextLink = ({ href, to, children, className = "", testId }) => {
  const cls = `group inline-flex items-center gap-1.5 text-fg underline-offset-4 decoration-white/30 hover:decoration-signal hover:text-signal transition-colors ${className}`;
  const icon = <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:-translate-y-[1px] group-hover:translate-x-[1px]" />;
  if (to) return <Link to={to} className={cls} data-testid={testId}>{children}{icon}</Link>;
  return <a href={href} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testId}>{children}{icon}</a>;
};
